<template>
  <div class="-numeric-marker" :class="{ '-active': active }">
    <div v-if="showLine" class="-line"></div>
    <span class="-number">{{ value }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },
    showLine: {
      type: Boolean,
      default: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
